import {
  fetchUserTOS,
  getUserTOSConfig,
  updateUserTOS,
  UserTOS
} from '@/common/services/account/termsOfServices';
import { RootState } from '@/common/store';
import { ActionTree, MutationTree, Module as VuexModule } from 'vuex';

interface UserState {
  user: {
    tos: UserTOS;
  };
}

const state: UserState = {
  user: {
    tos: undefined
  }
};

const mutations: MutationTree<UserState> = {
  setUserTos(state: UserState, tos: UserTOS) {
    state.user.tos = tos;
  }
};

export const actions: ActionTree<UserState, RootState> = {
  async updateUserTOS({ commit }, updatedTOS: UserTOS) {
    await updateUserTOS(updatedTOS);
    commit('setUserTos', updatedTOS);
  },
  async fetchAndSaveTOS({ commit }) {
    const userTOS = await fetchUserTOS();
    commit('setUserTos', userTOS);
  },
  async checkShowTermsOfServices({ dispatch, state }): Promise<boolean> {
    try {
      const tosConfig = getUserTOSConfig();
      // Do not show TOS if no config is setup or TOS check is disabled
      if (!tosConfig || !tosConfig.enabled) {
        return false;
      }
      // Fetch the latest User TOS if not already fetched
      if (!state.user.tos) {
        await dispatch('fetchAndSaveTOS');
      }

      if (state.user.tos.tosVersion !== tosConfig.version) {
        return true;
      }
      return !state.user.tos.accepted;
    } catch (error) {
      console.error(error);
      // Assume the user has not accepted the TOS
      return true;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
} as VuexModule<UserState, RootState>;
